export enum ProjectStatusEnum {
  Draft = 'Draft',
  InProgress = 'In Progress',
  Complete = 'Complete',
  Cancelled = 'Cancelled',
}
